import { Controller } from "@hotwired/stimulus";

/**
 * Handles inbox email compose form interactions
 * - Customer selection dropdown with search
 * - Toggle between existing customer and new recipient
 */
export default class extends Controller {
  static targets = [
    "customerId",
    "dropdownContainer",
    "selectedName",
    "customerList",
    "searchInput",
    "customerItem",
    "emailInputSection",
    "nameSection"
  ];

  static values = {
    noEmailLabel: String,
    newEmailAddressLabel: String
  };

  connect() {
    this.boundCloseDropdown = this.closeDropdownOnOutsideClick.bind(this);
    document.addEventListener("click", this.boundCloseDropdown);
  }

  disconnect() {
    document.removeEventListener("click", this.boundCloseDropdown);
  }

  toggleDropdown(event) {
    event.preventDefault();
    event.stopPropagation();

    if (this.hasCustomerListTarget) {
      this.customerListTarget.classList.toggle("hidden");

      if (!this.customerListTarget.classList.contains("hidden") && this.hasSearchInputTarget) {
        this.searchInputTarget.focus();
      }
    }
  }

  closeDropdownOnOutsideClick(event) {
    if (!this.hasDropdownContainerTarget) return;

    if (!this.dropdownContainerTarget.contains(event.target)) {
      this.closeDropdown();
    }
  }

  closeDropdown() {
    if (this.hasCustomerListTarget) {
      this.customerListTarget.classList.add("hidden");
    }
  }

  selectCustomer(event) {
    const item = event.currentTarget;
    const customerId = item.dataset.id;
    const customerName = item.dataset.name;
    const customerEmail = item.dataset.email;

    if (this.hasCustomerIdTarget) {
      this.customerIdTarget.value = customerId;
    }

    if (this.hasSelectedNameTarget) {
      const displayText = `${customerName} (${customerEmail || this.noEmailLabelValue})`;
      this.selectedNameTarget.textContent = displayText;
      this.selectedNameTarget.classList.remove("text-gray-500", "dark:text-gray-400");
      this.selectedNameTarget.classList.add("text-gray-900", "dark:text-gray-100");
    }

    this.hideManualInputSections();
    this.closeDropdown();
  }

  selectNewRecipient(event) {
    event.preventDefault();

    if (this.hasCustomerIdTarget) {
      this.customerIdTarget.value = "";
    }

    if (this.hasSelectedNameTarget) {
      this.selectedNameTarget.textContent = this.newEmailAddressLabelValue;
      this.selectedNameTarget.classList.remove("text-gray-900", "dark:text-gray-100");
      this.selectedNameTarget.classList.add("text-gray-500", "dark:text-gray-400");
    }

    this.showManualInputSections();
    this.closeDropdown();
  }

  hideManualInputSections() {
    if (this.hasEmailInputSectionTarget) {
      this.emailInputSectionTarget.classList.add("hidden");
    }
    if (this.hasNameSectionTarget) {
      this.nameSectionTarget.classList.add("hidden");
    }
  }

  showManualInputSections() {
    if (this.hasEmailInputSectionTarget) {
      this.emailInputSectionTarget.classList.remove("hidden");
    }
    if (this.hasNameSectionTarget) {
      this.nameSectionTarget.classList.remove("hidden");
    }
  }

  filterCustomers(event) {
    const query = event.target.value.toLowerCase().trim();

    this.customerItemTargets.forEach((item) => {
      if (item.dataset.action?.includes("selectNewRecipient")) {
        return;
      }

      const name = (item.dataset.name || "").toLowerCase();
      const email = (item.dataset.email || "").toLowerCase();

      const matches = name.includes(query) || email.includes(query);
      item.classList.toggle("hidden", !matches);
    });
  }
}
